"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImgWithLoadingState = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var img_with_loading_circle_1 = require("./img-with-loading-circle");
var img_with_preview_1 = require("./img-with-preview");
exports.ImgWithLoadingState = (0, react_1.memo)(function (_a) {
    var fullImgSrc = _a.fullImgSrc, previewImgSrc = _a.previewImgSrc, _b = _a.alt, alt = _b === void 0 ? '' : _b;
    return previewImgSrc === undefined ? (react_1.default.createElement(img_with_loading_circle_1.ImgWithLoadingCircle, { src: fullImgSrc, alt: alt })) : (react_1.default.createElement(img_with_preview_1.ImgWithPreview, { fullImgSrc: fullImgSrc, previewImgSrc: previewImgSrc, alt: alt }));
});
exports.ImgWithLoadingState.displayName = 'ImgWithLoadingState';
